import apiClient from './apiClient';

/**
 * Subscription-Info abrufen
 */
export const getSubscription = async () => {
  const response = await apiClient.get('/stripe/subscription');
  return response.data;
};

/**
 * Plan-Limits und aktuelle Nutzung abrufen
 */
export const getPlanLimits = async () => {
  const response = await apiClient.get('/auth/limits');
  return response.data;
};

/**
 * Checkout Session erstellen und zu Stripe weiterleiten
 * @param {string} plan - STARTER, PROFESSIONAL, BUSINESS
 * @param {string} billingCycle - MONTHLY, YEARLY
 * @param {object} options - Zusätzliche Optionen
 * @param {boolean} options.acceptKiLimitExceeded - Bei Downgrade: KI-Limit-Überschreitung akzeptieren
 */
export const createCheckoutSession = async (plan, billingCycle, options = {}) => {
  const response = await apiClient.post('/stripe/create-checkout-session', {
    plan,
    billingCycle,
    ...options
  });
  return response.data;
};

/**
 * Stripe Customer Portal öffnen (für Rechnungen, Zahlungsmethoden, Kündigung)
 */
export const createCustomerPortal = async () => {
  const response = await apiClient.post('/stripe/customer-portal');
  return response.data;
};

/**
 * Zu Stripe Checkout weiterleiten oder Upgrade durchführen
 * Bei bestehendem Abo wird direkt geupgradet (mit Proration)
 * @param {string} plan - STARTER, PROFESSIONAL, BUSINESS
 * @param {string} billingCycle - MONTHLY, YEARLY
 * @param {object} options - Zusätzliche Optionen (z.B. acceptKiLimitExceeded)
 */
export const redirectToCheckout = async (plan, billingCycle, options = {}) => {
  const data = await createCheckoutSession(plan, billingCycle, options);

  // Bei direktem Upgrade (bestehendes Abo) keine Weiterleitung
  if (data.upgraded) {
    return data;
  }

  // Sonst zu Stripe Checkout weiterleiten
  if (data.url) {
    window.location.href = data.url;
  }
  return data;
};

/**
 * Zum Stripe Customer Portal weiterleiten (öffnet in neuem Tab)
 */
export const redirectToCustomerPortal = async () => {
  const data = await createCustomerPortal();
  if (data.url) {
    // Open in new tab to avoid navigation issues with back button
    window.open(data.url, '_blank', 'noopener,noreferrer');
  }
  return data;
};

/**
 * Downgrade-Impact prüfen
 * Gibt zurück, welche Pläne Probleme verursachen würden
 */
export const checkDowngradeImpact = async () => {
  const response = await apiClient.get('/stripe/downgrade-check');
  return response.data;
};

/**
 * Plan-Wechsel Vorschau - Exakte Berechnung von Stripe
 * @param {string} plan - STARTER, PROFESSIONAL, BUSINESS
 * @param {string} billingCycle - MONTHLY, YEARLY
 */
export const previewPlanChange = async (plan, billingCycle) => {
  const response = await apiClient.post('/stripe/preview-plan-change', {
    plan,
    billingCycle
  });
  return response.data;
};

/**
 * Plan kündigen (zum Periodenende)
 */
export const cancelSubscription = async () => {
  const response = await apiClient.post('/stripe/cancel');
  return response.data;
};

/**
 * Kündigung widerrufen
 */
export const reactivateSubscription = async () => {
  const response = await apiClient.post('/stripe/reactivate');
  return response.data;
};

/**
 * Organisation komplett löschen
 */
export const deleteOrganisation = async (confirmationName) => {
  const response = await apiClient.delete('/stripe/organisation', {
    data: { confirmationName }
  });
  return response.data;
};

// ============================================
// VOICE ASSISTANT ADDON
// ============================================

/**
 * Voice Assistant Abo-Status abrufen
 */
export const getVoiceAssistantSubscription = async () => {
  const response = await apiClient.get('/stripe/voice-assistant/subscription');
  return response.data;
};

/**
 * Voice Assistant Checkout Session erstellen und zu Stripe weiterleiten
 */
export const createVoiceAssistantCheckout = async () => {
  const response = await apiClient.post('/stripe/voice-assistant/checkout');
  return response.data;
};

/**
 * Zu Voice Assistant Checkout weiterleiten
 */
export const redirectToVoiceAssistantCheckout = async () => {
  const data = await createVoiceAssistantCheckout();
  if (data.url) {
    window.location.href = data.url;
  }
  return data;
};

/**
 * Voice Assistant Abo kündigen
 */
export const cancelVoiceAssistantSubscription = async () => {
  const response = await apiClient.post('/stripe/voice-assistant/cancel');
  return response.data;
};

/**
 * Voice Assistant Kündigung widerrufen
 */
export const reactivateVoiceAssistantSubscription = async () => {
  const response = await apiClient.post('/stripe/voice-assistant/reactivate');
  return response.data;
};
